import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

const REACT_APP_END_POINT_SUBSCRIBE_EMAIL_UPDATES =
  process.env.REACT_APP_END_POINT_SUBSCRIBE_EMAIL_UPDATES;

export const subscribe_Email_Update_Api = createAsyncThunk(
  "subscribe/email/updates",
  async (patchData, thunkApi) => {
    try {
      const result = fetchInterceptors(
        REACT_APP_END_POINT_SUBSCRIBE_EMAIL_UPDATES,
        "POST",
        patchData
      );
      return result;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const subscribe_Email_Update_Slice = createSlice({
  name: "changeApiKey",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    loading: null,
  },
  reducers: {
    setDefault_Subscribe_Email_Update: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribe_Email_Update_Api.pending, (state) => {
        state.loading = true;
      })
      .addCase(subscribe_Email_Update_Api.fulfilled, (state, action) => {
        state.response = action.payload;
        state.success = action.payload?.success;
        state.statusCode = action.payload?.code;
        state.loading = false;
      })
      .addCase(subscribe_Email_Update_Api.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_Subscribe_Email_Update } =
  subscribe_Email_Update_Slice.actions;
export default subscribe_Email_Update_Slice.reducer;
